import { NeoTaxEnvironment, ssoProviderNameSchema } from '@common/neo.tax';
import z from 'zod';

const EnvSchema = z.object({
  REACT_APP_BACKEND_BASE_URL: z.string(),
  REACT_APP_DISABLE_RECAPTCHA: z
    .enum(['true', 'false'])
    .transform((value) => value === 'true')
    .prefault('false'),
  REACT_APP_ENTERPRISE_SSO_DEFAULT_PROVIDER_ID: z
    .preprocess((value) => (value ? value : undefined), ssoProviderNameSchema.optional())
    .optional(),
  REACT_APP_ENTERPRISE_SSO_LOGIN_ONLY: z.enum(['true', 'false']).transform((value) => value === 'true'),
  REACT_APP_FINCH_CLIENT_ID: z.string(),
  REACT_APP_FIREBASE_API_KEY: z.string(),
  REACT_APP_FIREBASE_APP_ID: z.string(),
  // Non-empty: an empty value still constructs a ReCaptchaEnterpriseProvider, which throws on
  // every page load for every user and reports to Sentry from inside a catch that keeps auth up,
  // so the breakage is invisible except as permanent error noise.
  REACT_APP_FIREBASE_APP_CHECK_SITE_KEY: z.string().min(1),
  REACT_APP_FIREBASE_PROJECT_ID: z.string(),
  REACT_APP_FIREBASE_RECAPTCHA_KEY: z.string(),
  REACT_APP_FS_ORG_ID: z.string(),
  REACT_APP_GOOGLE_OAUTH_CLIENT_ID: z.string(),
  REACT_APP_GOOGLE_OAUTH_ENDPOINT: z.string(),
  REACT_APP_GTM_ID: z.string(),
  REACT_APP_GUSTO_CLIENT_ID: z.string(),
  REACT_APP_GUSTO_URL: z.string(),
  REACT_APP_HUBSPOT_CHAT_ID: z.string(),
  REACT_APP_LAUNCHDARKLY_ID: z.string(),
  REACT_APP_MAX_USER_INACTIVITY_SECONDS: z.preprocess((value) => parseInt(`${value}`), z.number().positive()),
  REACT_APP_MICROSOFT_OAUTH_CLIENT_ID: z.string(),
  REACT_APP_NEO_TAX_ENV: z.enum(NeoTaxEnvironment),
  REACT_APP_ONE_SCHEMA_CLIENT_ID: z.string(),
  // A deploy preview's own copies of the OneSchema templates its branch changed, as a JSON object
  // from each template's key to its copy's (projects/oneschema/scripts/preview.mjs). Empty everywhere
  // else, so every importer opens the template itself.
  REACT_APP_ONE_SCHEMA_PREVIEW_TEMPLATES: z
    .string()
    .prefault('{}')
    .transform((value) => JSON.parse(value))
    .pipe(z.record(z.string(), z.string())),
  REACT_APP_QUICKBOOKS_CLIENT_ID: z.string(),
  REACT_APP_SENTRY_DSN: z.string(),
  REACT_APP_SENTRY_RELEASE: z.string(),
  REACT_APP_THOMSON_REUTERS_API_URL: z.string(),
  // set to true when running e2e tests, see "e2e_task_runner" in circleci config
  REACT_APP_USE_FIREBASE_EMULATOR: z
    .enum(['true', 'false'])
    .transform((value) => value === 'true')
    .prefault('false'),
  REACT_APP_VERSION: z.string(),
});

export const env = Object.freeze(EnvSchema.parse(process.env));
